<form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-validation">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{modalTitle}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>

      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang.code }}</label>
        <input type="text" class="form-control" formControlName="code"
          [ngClass]="formErrorClass(createForm.controls.code, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.code, value:createForm.controls.code, submitted:createFormSubmitted }">
        </ng-template>


      </div>

      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang.businessName }}</label>
        <input type="text" class="form-control" formControlName="b_name"
          [ngClass]="formErrorClass(createForm.controls.b_name, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.b_name, value:createForm.controls.b_name, submitted:createFormSubmitted }">
        </ng-template>

      </div>

      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang.address }}</label>
        <input type="text" class="form-control" formControlName="address"
          [ngClass]="formErrorClass(createForm.controls.address, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.address, value:createForm.controls.address, submitted:createFormSubmitted }">
        </ng-template>


      </div>


      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang.zipCode }}</label>
        <input type="text" class="form-control" formControlName="zip_code"
          [ngClass]="formErrorClass(createForm.controls.zip_code, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.zip_code, value:createForm.controls.zip_code, submitted:createFormSubmitted }">
        </ng-template>


      </div>


      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang.city }}</label>
        <input type="text" class="form-control" formControlName="city"
          [ngClass]="formErrorClass(createForm.controls.city, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.city, value:createForm.controls.city, submitted:createFormSubmitted }">
        </ng-template>


      </div>



      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang.province }}</label>
        <input type="text" class="form-control" formControlName="province"
          [ngClass]="formErrorClass(createForm.controls.province, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.province, value:createForm.controls.province, submitted:createFormSubmitted }">
        </ng-template>


      </div>


      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang.taxCode }}</label>
        <input type="text" class="form-control" formControlName="tax_code"
          [ngClass]="formErrorClass(createForm.controls.tax_code, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.tax_code, value:createForm.controls.tax_code, submitted:createFormSubmitted }">
        </ng-template>


      </div>


      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang.fiscalCode }}</label>
        <input type="text" class="form-control" formControlName="fiscal_code"
          [ngClass]="formErrorClass(createForm.controls.fiscal_code, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.fiscal_code, value:createForm.controls.fiscal_code, submitted:createFormSubmitted }">
        </ng-template>

      </div>


      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang.phone }}</label>
        <input type="text" class="form-control" formControlName="phone"
          [ngClass]="formErrorClass(createForm.controls.phone, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.phone, value:createForm.controls.phone, submitted:createFormSubmitted }">
        </ng-template>



      </div>

      <div class="col-sm-6" formArrayName="send_email">
        <label>{{lang.email}}</label>
        <div class="form-group row" *ngFor="let email of send_email().controls; let i=index">
          <div class="col-sm-10">
            <input type="text" class="form-control" formControlName="{{i}}"
              [ngClass]="formErrorClass(send_email().controls[i], createFormSubmitted)">

            <ng-template [ngTemplateOutlet]="ErrorMsg"
              [ngTemplateOutletContext]="{msg:createFormErrorMsg.send_email, value:send_email().controls[i], submitted:createFormSubmitted }">
            </ng-template>

          </div>
          <div class="col-sm-1">
            <button class="btn btn-primary pull-right" type="button" (click)="removeEmail(i)"
              *ngIf=" i!=(send_email().controls.length-1) ">
              <i class="fa fa-trash-o"></i>
            </button>
            <button class="btn btn-primary pull-right" type="button" (click)="addEmail()"
              *ngIf=" i==(send_email().controls.length-1) ">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>



      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang.website }}</label>
        <input type="text" class="form-control" formControlName="website"
          [ngClass]="formErrorClass(createForm.controls.website, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.website, value:createForm.controls.website, submitted:createFormSubmitted }">
        </ng-template>


      </div>


      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang.macroSector }}</label>
        <input type="text" class="form-control" formControlName="macro_sector"
          [ngClass]="formErrorClass(createForm.controls.macro_sector, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.macro_sector, value:createForm.controls.macro_sector, submitted:createFormSubmitted }">
        </ng-template>


      </div>


      <div class="col-sm-12" formArrayName="attachments">
        <label>{{ lang.attachments }}</label>
        <div class="form-group row" *ngFor="let link of attachments().controls; let i = index;" [formGroupName]="i">
          <div class="col-sm-11">
            <input type="file" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment1($event,i)"
              formControlName="link" appFileDesign>

            <ng-template [ngTemplateOutlet]="ErrorMsg"
              [ngTemplateOutletContext]="{msg:createFormErrorMsg.attachments, value:attachments().controls[i].controls['link'], submitted:createFormSubmitted }">
            </ng-template>

          </div>
          <div class="col-sm-1">
            <button class="btn btn-primary pull-right" type="button" (click)="removeAttachment(i)"
              *ngIf=" i!=(attachments().controls.length-1) ">
              <i class="fa fa-trash-o"></i>
            </button>
            <button class="btn btn-primary pull-right" type="button" (click)="addAttachment()"
              *ngIf=" i==(attachments().controls.length-1) ">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="col-sm-12" formArrayName="attachments_uploaded">

        <div class="form-group row" *ngFor="let image of attachments_uploaded().controls; let i=index">
          <div class="col-sm-11">
            <input type="hidden" class="form-control" formControlName="{{i}}">
            <input type="hidden" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment($event,i)"
              value="{{image.value.split('/').pop()}}">

            <!-- <a (click)="imagePreview(image.value)">{{image.value.split('/').pop()}}</a> -->
            <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/customers/{{image.value.split('/').pop()}}"
              target="_blank">{{image.value.split('/').pop()}}</a>

          </div>
          <div class="col-sm-1">
            <button class="btn btn-primary pull-right" type="button" (click)="removeAttachmentUploaded(i)">
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
        </div>
      </div>



      <!-- <div class="form-group col-sm-6">
                            <label for="first-name">Teacher</label>
                            <input type="text" class="form-control" formControlName="teacher"
                              [ngClass]="formErrorClass(createForm.controls.teacher, createFormSubmitted)">

                          </div> -->




      <div class="form-group col-sm-6">
        <button type="submit" class="btn btn-primary">{{ lang.submit }}</button>

      </div>
      <div class="form-group col-sm-4">
      </div>
      <div class="form-group col-sm-2">
      </div>

    </div>
  </div>

</form>